import { useEffect } from 'react'

type UseDisableBodyScrollOptions = {
  mobileOnly?: boolean
}

const isMobileViewport = () =>
  typeof window !== 'undefined' &&
  typeof window.matchMedia === 'function' &&
  window.matchMedia('(max-width: 668px)').matches

export const useDisableBodyScroll = (disabled: boolean, options: UseDisableBodyScrollOptions = {}) => {
  useEffect(() => {
    const shouldDisableBodyScroll = disabled && (!options.mobileOnly || isMobileViewport())

    if (shouldDisableBodyScroll) {
      document.body.classList.add('overflow-hidden')
    } else {
      document.body.classList.remove('overflow-hidden')
    }

    return () => {
      if (shouldDisableBodyScroll) {
        document.body.classList.remove('overflow-hidden')
      }
    }
  }, [disabled, options.mobileOnly])
}
